import {lazy} from "react";

export const DiscountsAsync = lazy(() => import('../ui/Discounts'))
